import { __decorate } from "tslib";
import Vue from 'vue';
import Drawer from '@blade/common/components/paint/index.vue';
import VideoPlayer from '@blade-sxp/monitor/components/player/simple-player.vue';
import { Component, Prop } from 'vue-property-decorator';
let VideoDrawer = class VideoDrawer extends Vue {
    rtspAddress;
    dataSource;
    buttons;
    limits;
    isPlayFlag;
    directionConfig;
    loading = true;
    isPlay = true;
    handelStopOrStart() {
        if (this.isPlay)
            this.$refs.video.stop();
        else {
            this.$refs.video.play();
            this.loading = true;
        }
        this.isPlay = !this.isPlay;
    }
    handlePlaying() {
        this.loading = false;
    }
    drawend(atlas) {
        this.$emit('drawend', atlas);
    }
};
__decorate([
    Prop()
], VideoDrawer.prototype, "rtspAddress", void 0);
__decorate([
    Prop()
], VideoDrawer.prototype, "dataSource", void 0);
__decorate([
    Prop()
], VideoDrawer.prototype, "buttons", void 0);
__decorate([
    Prop()
], VideoDrawer.prototype, "limits", void 0);
__decorate([
    Prop()
], VideoDrawer.prototype, "isPlayFlag", void 0);
__decorate([
    Prop()
], VideoDrawer.prototype, "directionConfig", void 0);
VideoDrawer = __decorate([
    Component({
        name: 'DrawWithVideo',
        components: {
            Drawer,
            VideoPlayer
        },
        i18n: {},
    })
], VideoDrawer);
export default VideoDrawer;
